import { useEffect, useRef } from 'react';

const collections = [
  {
    number: '01',
    name: 'Urban Essence',
    desc: 'Core pieces. Everyday power.',
  },
  {
    number: '02',
    name: 'Silent Rebel',
    desc: 'Minimal. Intentional. Unseen dominance.',
  },
  {
    number: '03',
    name: 'Neon Nights',
    desc: 'After dark, everything changes.',
  },
  {
    number: '04',
    name: 'Metropolis Pulse',
    desc: 'Built for those who own the city.',
  },
];

export default function CollectionsSection() {
  const labelRef = useRef<HTMLDivElement>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.08 }
    );
    if (labelRef.current) observer.observe(labelRef.current);
    cardRefs.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="section-collections"
      data-section="Collections"
      className="w-full py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
      style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
    >
      <div className="w-full px-8 md:px-16">

        {/* Header row */}
        <div
          ref={labelRef}
          className="reveal flex flex-col md:flex-row md:items-end justify-between gap-4 md:gap-6 mb-10 md:mb-20"
          style={{ borderBottom: '1px solid rgba(255,255,255,0.07)', paddingBottom: '28px' }}
        >
          <div>
            <span className="block font-display text-[9px] tracking-[0.5em] uppercase text-white/35 mb-4">Collections</span>
            <h2
              className="font-display font-black uppercase text-white leading-none"
              style={{ fontSize: 'clamp(32px, 5.5vw, 64px)', letterSpacing: '-0.025em' }}
            >
              Curated for<br />
              <span className="chrome-text">the Bold</span>
            </h2>
          </div>
          <p className="font-display text-xs text-white/30 tracking-widest uppercase max-w-xs">
            Four drops. One identity.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px">
          {collections.map((col, i) => (
            <div
              key={col.name}
              ref={(el) => { cardRefs.current[i] = el; }}
              className={`reveal reveal-delay-${i + 1} group relative p-8 md:p-10 cursor-pointer transition-all duration-500 hover:bg-white/[0.025]`}
              style={{
                borderLeft: '1px solid rgba(255,255,255,0.07)',
                borderBottom: '1px solid rgba(255,255,255,0.07)',
              }}
            >
              {/* Number */}
              <span
                className="font-display font-black chrome-text block mb-10 transition-opacity duration-500 group-hover:opacity-80"
                style={{ fontSize: '56px', lineHeight: 1, opacity: 0.25 }}
              >
                {col.number}
              </span>

              {/* Name */}
              <h3 className="font-display font-bold text-white uppercase tracking-wide mb-3 text-base">
                {col.name}
              </h3>

              {/* Separator */}
              <div
                className="w-6 h-px mb-4 transition-all duration-500 group-hover:w-12"
                style={{ background: 'linear-gradient(90deg, #C0C0C0, #D4AF37)' }}
              />

              {/* Description */}
              <p className="font-display text-xs font-light text-white/40 leading-relaxed tracking-wide">
                {col.desc}
              </p>

              {/* Hover arrow */}
              <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-white/30 text-sm" />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
